import {Component, OnDestroy, OnInit} from '@angular/core';
import {first, Subscription} from 'rxjs';
import {AppDialogService} from '../services/AppDialogService';
import {AssignmentService,} from '../services/AssignmentService';
import {FormService} from '../services/FormService';
import {FormsModule} from '@angular/forms';
import {Message} from 'primeng/message';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Button} from 'primeng/button';
import {InputGroup} from 'primeng/inputgroup';
import {InputGroupAddon} from 'primeng/inputgroupaddon';
import {Select} from 'primeng/select';
import {SystemService} from '../services/SystemService';
import {TranslocoPipe} from '@ngneat/transloco';

declare var Yii: any;

const apiUrl = environment.api;

@Component({
  selector: 'ng-chain-branch-selector',
  templateUrl: './chain-branch-selector.html',
  imports: [
    FormsModule,
    Message,
    Button,
    InputGroup,
    InputGroupAddon,
    Select,
    TranslocoPipe
  ]
})
export class ChainBranchSelector implements OnInit, OnDestroy {

  public Yii = Yii;
  private subss: Subscription[] = [];

  constructor(
    public asvc: AssignmentService,
    public fsvc: FormService,
    public dialogs: AppDialogService,
    private httpClient: HttpClient,
    public sysvc: SystemService,
  ) {
  }

  ngOnInit() {
    this.subss.push(this.asvc.OnChainAssigned.subscribe({next: () => this.getChainAssignment()}))
    this.getChainAssignment();
  }

  ngOnDestroy() {
    this.subss.forEach(sub => sub.unsubscribe());
  }

  public getChainAssignment() {
    this.asvc.CheckAssignmentCreated()
    this.asvc.ReloadChainBranches();
    this.asvc.OnChainChanged.emit(this.asvc.currentChainId);
  }

  public getBranchAssignments() {
    if (!this.asvc.cchain) {
      return;
    }

    const cbranchid = Number(this.asvc.currentBranchId);
    this.asvc.OnBranchChanged.emit(cbranchid);
  }

  public setBranchSettings() {
    this.dialogs.Confirm(
      Yii.t("app", "Branch Settings"),
      Yii.t("app", "Would you like to use the Chain Settings as default for this Branch?")
    )
      .onClose
      .pipe(first())
      .subscribe(result => {
        if (result) {

          const chainId = this.asvc.GetCurrentChainId();
          const branchId = Number(this.asvc.currentBranchId);
          const formId = this.fsvc.formId;

          this.httpClient.get(
            `${apiUrl}/api/forms/setBuilderBranchSettings/${formId}?chainId=${chainId}&branchId=${branchId}&tabId=1&token=${localStorage.getItem('apiToken')}`
          )
            .pipe(first())
            .subscribe({
              next: (data: { status: boolean, message: string }) => {
                if (data.status) {
                  this.asvc.AddAssignment(chainId, branchId);
                } else {
                  this.dialogs.Alert("Error", data.message);
                }
              },
              error: (error: HttpErrorResponse) => {
                this.dialogs.Alert("Error", error.error.message);
              }
            })

        }
      });
  }

  public DeleteBranchSettings() {
    if (typeof this.asvc.cchain == 'object' && this.asvc.GetCurrentBranchId() === 0) {
      this.dialogs.Alert("Error", Yii.t('app', 'Branch was not selected!'));
      return;
    }

    this.dialogs.Confirm(
      Yii.t("app", "Unset Branch Settings"),
      Yii.t("app", "Would you like to unset Settings for this Branch?")
    ).onClose.subscribe(result => {
      if (result) {

        const chainId = this.asvc.GetCurrentChainId();
        const branchId = this.asvc.GetCurrentBranchId();
        const formId = this.asvc.formId;

        this.httpClient.get(
          `${apiUrl}/api/forms/unsetBuilderBranchSettings/${formId}?chainId=${chainId}&branchId=${branchId}&tabId=1&token=${localStorage.getItem('apiToken')}`
        )
          .pipe(first())
          .subscribe({
            next: (data: { status: boolean, message: string }) => {
              if (data.status) {
                this.asvc.RemoveAssignment(chainId, branchId);
              } else {
                this.dialogs.Alert("Error", data.message);
              }
            },
            error: (error: HttpErrorResponse) => {
              this.dialogs.Alert("Error", error.error.message);
            }
          })
      }
    });
  }
}
